/**
 * Rounds a number to the specified number of decimal places.
 */
export const roundToDecimals = (value: number, decimals: number = 2) =>
  Number(Math.round(Number(value + 'e' + decimals)) + 'e-' + decimals);

/**
 * Rounds a number to the nearest increment based on digits from the left,
 * but with special handling for small values:
 *  - If |value| < 1, round up to the next 0.5 increment.
 *  - If 1 <= |value| < 10, round up to the next 5.
 *  - Otherwise, use the digitsFromLeft approach.
 */
export const roundToNearest = (value: number, digitsFromLeft = 2) => {
  const sign = value < 0 ? -1 : 1;
  const absVal = Math.abs(value);

  // Handle very small numbers
  if (absVal < 1) {
    // Round to next 0.5
    return sign * Math.ceil(absVal / 0.5) * 0.5;
  }

  // Handle single-digit numbers
  if (absVal < 10) {
    // Round to next 5
    return sign * Math.ceil(absVal / 5) * 5;
  }

  // Handle larger numbers
  const num = Math.abs(roundToDecimals(value, 0));
  const length = num.toString().length;
  // Calculate the power of 10 based on the number length and digitsFromLeft
  const divider = Math.pow(
    10,
    length > digitsFromLeft ? length - digitsFromLeft : 1,
  );

  // Round up
  const roundedNum = Math.ceil((num + 1) / divider) * divider;

  return sign * roundedNum;
};
